import React from 'react';

import { BasicMail, BasicPhone } from '../../icons/basic';
import { TextLink } from '../buttons/TextLink';
import { Typography } from '../typography/Typography';

type Props = {
  name: string;
  image?: React.ReactElement;
  jobTitle: string;
  beschrijving: string;
  contactInformation?: Array<{
    type: string;
    emailOfTelefoonnummer: string;
    beschrijving?: string;
  }>
}

export const Contact = ({
  name,
  image,
  jobTitle,
  beschrijving,
  contactInformation,
}: Props) => {

  const formatEmailPhone = (contact: { type: string; emailOfTelefoonnummer: string }) => {
    if (contact.type === 'email') {
      if (contact.emailOfTelefoonnummer.length > 30) {
        return contact.emailOfTelefoonnummer.split('@').join('@&#x200b;');
      }
    }

    return contact.emailOfTelefoonnummer;
  };

  return (
    <div className="hyphens-auto bg-contact p-6">
      <div className="mb-4 flex items-center space-x-4">
        {image ? (
          <div className="relative size-20 shrink-0 overflow-hidden rounded-full">
            {image}
          </div>
        ) : null}
        <div className="space-y-1">
          <Typography variant="title-body">
            {name}
          </Typography>
          <Typography variant="label-regular">
            {jobTitle}
          </Typography>
        </div>
      </div>

      <div className="mb-4 space-y-4">
        {contactInformation?.map((contact) => (
          <div
            key={contact.emailOfTelefoonnummer}
            className="space-y-1 break-words"
          >
            <TextLink
              iconLeft={contact.type === 'telefoonnummer' ? BasicPhone : BasicMail}
              size="small"
            >
              <a href={`${contact.type === 'telefoonnummer' ? 'tel:' : 'mailto:'}${contact.emailOfTelefoonnummer}`}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: formatEmailPhone(contact),
                  }}
                />
              </a>
            </TextLink>
            {contact.beschrijving ? (
              <Typography
                variant="label-small"
                className="ml-[1.875rem] flex flex-wrap"
              >
                {contact.beschrijving}
              </Typography>
            ) : null}
          </div>
        ))}
      </div>

      <Typography variant="label-small">
        {beschrijving}
      </Typography>
    </div>
  );
};
